import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-10 p-10 indicator-section"
}
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = { class: "row text-center" }
const _hoisted_4 = { class: "position-relative" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "card p-3 content-section mt-5" }
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = { style: {"font-size":"larger"} }
const _hoisted_10 = ["alt"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "d-flex justify-content-center align-items-center mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_PolarAreaChart = _resolveComponent("PolarAreaChart")!

  return (_ctx.indicatorList)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.translate("REPORT_KPI_RESULTS_HEADER")), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicatorList, (indicator, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "indicator-box col-md-3 indicator-box p-3",
              key: index
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "socre-background_image w-100px",
                    src: indicator.background_url,
                    alt: _ctx.translate(indicator.description)
                  }, null, 8, _hoisted_5),
                  _createElementVNode("img", {
                    class: "icon_score mx-auto",
                    src: indicator.img_url,
                    alt: _ctx.translate('INFO_REPORT_ICON_LABEL')
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h4", _hoisted_8, _toDisplayString(indicator.title), 1),
                  _createElementVNode("h3", {
                    style: _normalizeStyle({ color: indicator.color, backgroundColor: indicator.backgroundColor, borderRadius: '0.85rem', margin: '0 auto 8px', padding: '0 8px'})
                  }, [
                    _createElementVNode("b", _hoisted_9, _toDisplayString(_ctx.convertedValue(indicator.value)), 1),
                    _cache[0] || (_cache[0] = _createTextVNode("/100 ", -1))
                  ], 4),
                  _createVNode(_component_Popper, null, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "custom-tooltip",
                        innerHTML: _ctx.translate(indicator.tooltip)
                      }, null, 8, _hoisted_11)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "w-50px",
                        src: "/media/valored/info_report_icon.png",
                        alt: _ctx.translate('INFO_REPORT_ICON_LABEL')
                      }, null, 8, _hoisted_10)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("p", null, _toDisplayString(_ctx.translate(indicator.description)), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createVNode(_component_PolarAreaChart, {
              class: "w-100 h-100",
              chartData: _ctx.chartData,
              options: _ctx.options,
              plugins: _ctx.plugins,
              id: "indicatorChart"
            }, null, 8, ["chartData", "options", "plugins"])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            id: "legend-container",
            class: "ms-20 p-5 card"
          }, null, -1))
        ])
      ]))
    : _createCommentVNode("", true)
}